export const PROMO_LINK = 'https://www.youtube.com/embed/D_fitHg-1AM';
export const REPO_LINK = 'https://github.com/alexeikravchuk/rslang';